<template>
    <section>
        <div class="container">
            <h2 class="alfa fw-semibold mb-2">Contact Us</h2>
            <p class="beta">
                Please feel free to reach out to us using the form below, or simply use our provided email address. We are here to address any questions you may have.
            </p>

            <div class="row mt-2 mt-lg-5 gy-3">
                <div class="col-60 col-lg-25">
                    <form method="post" id="contact-form">
                      <input type="hidden" name="csrfmiddlewaretoken" :value="csrftoken">
                        <div class="row">
                            <div class="col-60">
                                <div class="form-group">
                                    <input
                                        id="id_full_name"
                                        name="full_name"
                                        v-model="fullName"
                                        type="text"
                                        required
                                        placeholder="Full name*"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-60 col-lg-30">
                                <div class="form-group">
                                    <input
                                        id="id_email"
                                        name="email"
                                        v-model="email"
                                        type="email"
                                        placeholder="E-mail*"
                                        required
                                    />
                                </div>
                            </div>

                            <div class="col-60 col-lg-30">
                                <div class="form-group">
                                    <input
                                        id="id_phone"
                                        name="phone"
                                        v-model="phone"
                                        type="tel"
                                        placeholder="Phone"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-60">
                                <div class="form-group">
                                    <textarea
                                        id="id_message"
                                        v-model="message"
                                        name="message"
                                        placeholder="Message*"
                                        required
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                      <div class="g-recaptcha"
                         data-sitekey="6LfOAHQUAAAAAPixnAMFNw2EQ4kWVx8U9DYJfois"
                         data-size="invisible"
                         data-callback="recaptchaOnSubmit">
                    </div>
                      <button type="submit"
                              class="base-btn transition btn-big btn-primary w-100" > Send your message </button>
                    </form>
                </div>

                <div class="col-60 col-lg-25 ms-auto">
                    <div class="mb-1">
                        <p class="text-black beta fw-semibold">Sportvideos365 GmbH</p>
                        <p>Cumberlandstrasse 40/4/1</p>
                        <p>1140 Vienna</p>
                        <p>Austria</p>
                    </div>

                    <div class="mb-1">
                        <p><strong>Legal registration number:</strong> FN 430195s</p>
                        <p><strong>Register Court:</strong> HG Vienna</p>
                        <p><strong>VAT:</strong> ATU69379102</p>
                        <p><strong>St.Nr.:</strong> 15219/7711</p>
                    </div>

                    <a href="mailto:info@sport.video" class="primary-c">info@sport.video</a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "ContactForm",
    props: {
      csrftoken: {
        type: String,
      },
      captcha: {
        type: String,
      },
    },
    data() {
        return {
            fullName: '',
            email: '',
            phone: '',
            message: ''
        }
    },
  mounted() {
      document.getElementById("contact-form").addEventListener('submit', function (event) {
        event.preventDefault();
        grecaptcha.reset();
        grecaptcha.execute();
      });
  }
}
</script>

<style lang="scss" scoped>
.form-group {
    margin-bottom: 1rem;
}

input,
textarea {
    width: 100%;
    border: 0.08rem solid #eaecf0;
    outline: none;
    border-radius: 0.3rem;
    font-size: 0.8rem;

    &:focus {
        border-color: var(--global-color-primary);
    }
}

input {
    height: 3rem;
    padding: 0 0.6rem;
}

textarea {
    resize: none;
    padding: 0.6rem;
    height: 6.2rem;
}

p {
    max-width: 37rem;

    &.text-black {
        margin-bottom: 0.4rem;
    }
}
</style>
